import React, { useState, useEffect } from "react";

import "./assets/scss/App.scss";
import Scores from "./components/Scores";
import Questions from "./components/Questions";

import { fetchAndProcessData, fetchAndProcessAndSlug } from './components/helpers/dataHelper';

import Summary from "./components/Summary";
import Popup from "./components/Popup";
import Button from "./components/Button";
function App() {


  var path = 'https://admin.echo-cms.be/api/';
  // var path = "https://echo-cms.ddev.site/api/";
  const [activeQuestion, setActiveQuestion] = useState(0);
  const [blocks, setBlocks] = useState(null);
  const [labels, setLabels] = useState(null);

  useEffect(() => {
    // Parse the query string parameters
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};

    // Iterate over all parameters and store them in an object
    for (let [key, value] of searchParams.entries()) {
      params[key] = value;
    }

    // Update the state with the parsed query parameters

    const blocksUrl = 'https://front.echo-cms.be/?account=wernerdevree&domain=front.echo-cms.be&page=json/blocks/all.json';



    fetchAndProcessAndSlug(blocksUrl)
      .then(({ data }) => {



        setBlocks(data);
      })
      .catch((error) => {
        console.error('Error fetching and processing data:', error);
      });

    const labelsUrl = 'https://front.echo-cms.be/?account=wernerdevree&domain=front.echo-cms.be&page=json/labels/all.json';



    fetchAndProcessAndSlug(labelsUrl)
      .then(({ data }) => {



        setLabels(data);
      })
      .catch((error) => {
        console.error('Error fetching and processing data:', error);
      });





    const url = 'https://front.echo-cms.be/?account=wernerdevree&domain=front.echo-cms.be&page=json/taxonomies/all.json';

    fetchAndProcessData(url)
      .then(({ categories, questions }) => {





        Object.values(categories).map((category) => {
          if (params[category.id]) {

            categories[category.id].score = parseInt(params[category.id]);

          }
        })


        Object.values(questions).map((question) => {
          if (params[question.id]) {
            questions[question.id].score = parseInt(params[question.id]);
          }
        })

        setCategories({ ...categories });
        setQuestions({ ...questions });


        if (params["question"]) {
          setActiveQuestion(parseInt(params["question"]));
          setStart(true);
        }


        setLoading(false)
      })
      .catch((error) => {
        console.error('Error fetching and processing data:', error);
      });
  }, []);



  const [popup, setPopup] = useState(null);
  const [query, setQuery] = useState("");
  const [start, setStart] = useState(null);


  const colors = [
    '#00a4e4', '#00a4e4', '#00a4e4', '#00a4e4', '#00a4e4',
    '#FF0000', '#FF0000', '#FF0000',
    '#FFD95B', '#FFD95B', '#FFD95B', '#FFD95B', '#FFD95B'
  ];

  // Define base colors for each group
  //const baseColors = ['#FF6347', '#4682B4', '#32CD32']; // Resultaat gericht (rood), opvolgen (blauw), verbetre
  const baseColors = ['#00a4e4', '#FF0000', '#FFD95B']; // Resultaat gericht (rood), opvolgen (blauw), verbeteren (geel)



  const params = new URLSearchParams(window.location.search);
  const urlLang = params.get("lang");


  const root = document.getElementById("root");


  const langId =

    urlLang ||
    root?.dataset.language ||
    "nl";




  const [questions, setQuestions] = useState([]);
  const [categories, setCategories] = useState({});
  const [loading, setLoading] = useState(true);
  const [scanResult, setScanResult] = useState(null);
  const debug = false;

  const navigateQuestion = (goTo) => {



    if (goTo === Object.values(questions).length) {





      let value = {};


      let converted = query.split("question=" + 12).join("question=" + 13);




      value.info = "<p><a href='https://apps.windrose.echo-cms.be/" + converted + "'>" + labels?.["view-online"]?.lang?.[langId]?.name + "</a></p>";



      // value.email = "wernerdevree@studio-echo.be";
      //value.email = "vannas@studio-echo.be";
      value.account = "wernerdevree";
      value.name = "onbekend";
      value.trap = "";
      value.language = langId;

      value.type = "zelfscan-anoniem";

      fetch(path + 'form-submit', {
        method: 'POST', // or 'PUT'
        body: JSON.stringify(value), // data can be `string` or {object}!
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => res.json())






    }

    setActiveQuestion(goTo);

  }



  useEffect(() => {

    let query = "?question=" + activeQuestion + "&lang=" + langId;

    Object.values(categories).map((category) => {
      // let total = 0;


      if (category.score) {
        query += "&" + category.id + "=" + category.score;
      }



      category.sub.forEach((s) => {

        //if (questions[s].score) {
        query += "&" + questions[s].id + "=" + questions[s].score;
        // }

      })



    })


    // history.push(query);

    setScanResult(query);
    setQuery(query);
  }, [questions, activeQuestion]);



  useEffect(() => {
    if (popup) {
      // Add overflow: hidden to the body
      document.body.style.overflow = 'hidden';
    } else {
      // Remove overflow: hidden from the body
      document.body.style.overflow = '';
    }

  }, [popup]); // Empty dependency array ensures this effect runs once on mount


  function handleClick(event, question, key) {


    let click = question;

    if (!click) {

      click = Object.values(questions)[key - 1];
    }

    setPopup(click);

  };



  return (
    <div className={"m-5"}>



      {(popup &&

        <Popup labels={labels} blocks={blocks} langId={langId} setPopup={setPopup} popup={popup} colors={colors} />



      )}



      {(loading ?
        <div className="flex justify-center items-center"><div>{labels?.["loading"]?.lang?.[langId]?.name}</div></div>
        :
        <div className="text-center">



          {(!start && !debug ?

            <div className="info mx-auto">
              <div dangerouslySetInnerHTML={{ __html: blocks?.["zelfscan---intro"]?.lang?.[langId]?.blocks }}></div>





              <Button onClick={() => setStart(true)}>{labels?.["start"]?.lang?.[langId]?.name}</Button>

              <div className="flex justify-center mt-3"><img style={{ maxWidth: "500px" }} className="rose" src="https://omg-s3-public.s3.eu-central-1.amazonaws.com/echo_files_prod/wernerdevree/huge_zelfscan%20roos-6968a537116c2.png" alt="Roos" /></div>


            </div>
            :





            (activeQuestion === Object.values(questions).length ?

              <>

                <Summary langId={langId} labels={labels} blocks={blocks} scanResult={scanResult} baseColors={baseColors} categories={categories} handleClick={handleClick} colors={colors} questions={questions} />

              </>

              :
              <Questions langId={langId} labels={labels} baseColors={baseColors} activeQuestion={activeQuestion} setActiveQuestion={navigateQuestion} colors={colors} categories={categories} questions={questions} setQuestions={setQuestions} />


            )



          )}






          {
            (true == false &&
              <Scores langId={langId} categories={categories} questions={questions} />

            )
          }



        </div >
      )}

    </div >
  );
}

export default App;